/**
 * Why a go-live / go-offline happened. Values are the server enum names
 * (`SoftphoneCampaignStateChangeReason`). Server side the reason reaches the request log and, on go
 * offline, decides whether the agent's presence record survives - only `WrapUp` keeps it.
 *
 * Its own module rather than living in `softphone.api.js`, so the softphone store can name a reason
 * without importing the api module (and the httpClient -> router -> store cycle behind it).
 *
 * - CONNECTION_LOST: the widget paused the campaign itself because its Telnyx connection dropped; it
 *   resumes the campaign on its own once the registration is back.
 * - CALL_SETUP_FAILED: the connection kept dropping as calls rang, so the widget stopped going live
 *   again and left the campaign paused - see `CALL_SETUP_DROP_LIMIT` in the softphone store.
 */
export const SOFTPHONE_STATE_CHANGE_REASON = Object.freeze({
  AGENT_ACTION: 'AgentAction',
  WRAP_UP: 'WrapUp',
  CONNECTION_LOST: 'ConnectionLost',
  CALL_SETUP_FAILED: 'CallSetupFailed'
})

/**
 * The longest `detail` sent with a go-offline. The server trims to the same length; this only keeps
 * the query string short.
 */
export const STATE_CHANGE_DETAIL_MAX_LENGTH = 200
